import React, { useEffect, useState } from "react";
import Chip from '@mui/material/Chip';
import { Box } from "@mui/material";
import ReservationStatusDialog from "./ReservationStatusDialog";

export default function ReservationStatusChip({status,onClick}){
    
    return (
      
      <Box>
        {/* <ReservationStatusDialog/> */}
        {status === "COMPLETE" && (
          <Chip color="success" label="Complete" onClick ={onClick} />
        )}

        {status === "CANCEL" && (
          <Chip color="error" label="Cancelled" onClick ={onClick}/>
        )}

        {status === "PENDING" && (
          <Chip color="warning" label="Pending"  onClick ={onClick}/>
        )}
      </Box>
    );
} 